<script lang="ts" setup>
  import { ref } from 'vue'
  import NavigationDesktop from '@/components/layout/NavigationDesktop.vue'
  import { useEventBus } from '@vueuse/core'
  import AppExtensions from '@/layouts/blocks/AppExtensions.vue'
  import AppBody from '@/layouts/blocks/AppBody.vue'
  import AppHeader from '@/layouts/blocks/AppHeader.vue'
  import AppNotReady from '@/layouts/blocks/AppNotReady.vue'
  import { whenTitropReady, whenTitropUnready } from '@/composables/useTitrop.ts'
  import { useAuthStore } from '@/stores'
  import NotificationPermissionBanner from '@/components/layout/NotificationPermissionBanner.vue'
  // import WorktimeChecker from '@/views/worktimechecker/WorktimeCheckerView.vue'

  const mainBody = ref<HTMLElement>()
  const alternateBody = ref<HTMLElement>()
  useEventBus('content:hide').on(() => {
    mainBody.value?.classList.add('hidden')
    alternateBody.value?.classList.remove('hidden')
  })
  useEventBus('content:show').on(() => {
    mainBody.value?.classList.remove('hidden')
    alternateBody.value?.classList.add('hidden')
  })

  const titropReady = ref(false)

  whenTitropReady(() => (titropReady.value = true))
  whenTitropUnready(() => (titropReady.value = false))

  if (import.meta.hot)
    import.meta.hot.on('vite:invalidate', () => {
      titropReady.value = false
      //TODO: re-invoke refresh whoami?
      void useAuthStore().refreshLoginState()
    })
</script>
<template>
  <template v-if="titropReady">
    <div>
      <NotificationPermissionBanner />
      <!--        <DynamicDialog />-->
      <!--        <AnnoucementContainer />-->
      <AppHeader />
      <div
        ref="mainBody"
        class="flex flex-row pb-20 md:pb-0">
        <NavigationDesktop class="hidden md:block md:flex-none flex-0 bg-white dark:bg-gray-900" />
        <AppBody />
      </div>
      <div
        id="alternate-main"
        ref="alternateBody"
        class="flex flex-row pb-20 md:pb-0" />
      <AppExtensions />
    </div>
  </template>
  <template v-else>
    <div>
      <div
        ref="mainBody"
        class="flex flex-row pb-20 md:pb-0">
        <AppNotReady />
      </div>
    </div>
  </template>
</template>
